module.exports = __webpack_public_path__ + "static/media/main-list-postcard.0c6e5ef6.png";